import { render, staticRenderFns } from "./ModalEmailTemplateNew.vue?vue&type=template&id=d40ffb0a&"
import script from "./ModalEmailTemplateNew.vue?vue&type=script&lang=js&"
export * from "./ModalEmailTemplateNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports